import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import Select from './select';
import useCreatable from './use-creatable';
import useStateManager from './use-state-manager';
var CreatableSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /*#__PURE__*/React.createElement(Select, _extends({
    ref: ref
  }, selectProps));
});
export { useCreatable };
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default CreatableSelect;